import api from './';

export default {
    /**
     * Get audit from model
     * @param modelName
     * @param id
     * @param params
     */
    get(modelName, id, params) {
        return api
            .get(`/audits/${modelName}/${id}`, { params })
            .then(response => {
                return response.data
            })
    },
};
